import { CommonMessages } from "../messages/validationMessages"
import * as Yup from 'yup'

export const addBankInfoSchema = Yup.object().shape({
    PaymentMethod: Yup.string()
        .required(CommonMessages.paymentType_required)
        .notOneOf(['0'], CommonMessages.paymentType_required),
        
    stripeSecretKey: Yup.string()
        .required(CommonMessages.stripeSecretKey_required),

    stripePublicKey: Yup.string()
        .required(CommonMessages.stripePublicKey_required),

})